const en_purch_quotationSales = {
    label: {
        btn_po: "process PO",
    }
}

export default en_purch_quotationSales;